import React from 'react';
import {Box} from '@mui/material';
import {imagekitStaticURL} from '../util/util.js';

const Image = ({imagekit_src, ...props})=><Box component="img"
    {...imagekit_src&&{src: imagekitStaticURL(imagekit_src)}} {...props}/>;

export default Image;
